(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('AsideMenuViewModel', asideMenuViewModelFactory);

  /** @ngInject */
  function asideMenuViewModelFactory(
    $translate,
    brand,
    checkUserRole,
    service,
    helperService,
    jwtHelper,
    sessionData,
    optionalFeaturesActions
  ) {
    // Feature codes for configurable menu items
    var FEATURE_CODES = {
      DAILYFINANCES: 'DAILYFINANCES',
      APPSITEDETAILS: 'APPSITEDETAILS',
      SAVINGS: 'SAVINGS',
      VOUCHERS: 'VOUCHERS',
      ROLLOVER: 'ROLLOVER',
      LOYALTY: 'LOYALTY',
      TRANSACTIONS: 'TRANSACTIONS',
      TOKENS: 'TOKENS',
      PRICING: 'PRICING',
      PERIODICSUMMARY: 'PERIODICSUMMARY',
      MONEYCHANGERJOURNAL: 'MONEYCHANGERJOURNAL',
    };

    function AsideMenuViewModel() {
      this.items = [];
      this.shouldHideSidebar = false;
      this._optionalFeatures = [];
      var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);
      var claims = token ? jwtHelper.decodeToken(token) : {};
      this._isCompanyUser = 'isCompanyLevel' in claims ? !!claims.isCompanyLevel : true;
      this._companyId = claims.companyId || null;
      this.refresh();
    }

    AsideMenuViewModel.prototype.destroy = function () {
      this.items = [];
    };

    AsideMenuViewModel.prototype.refresh = function () {
      var self = this;
      self.items = [];

      // Load optional features and build menu
      optionalFeaturesActions.getOptionalFeatures(self._companyId).then(function(features) {
        self._optionalFeatures = features || [];
        self._buildMenu();
      }).catch(function() {
        self._optionalFeatures = [];
        self._buildMenu();
      });
    };

    AsideMenuViewModel.prototype._hasFeature = function(featureCode) {
      return this._optionalFeatures.indexOf(featureCode) !== -1;
    };

    AsideMenuViewModel.prototype._buildMenu = function() {
      var self = this;
      self.items = [];
      // Cashier-only users see only Rollover menu item (not for R2W platform)
      // TODO add all vouchers for chasier role??
      if (checkUserRole.isCashier() && !checkUserRole.isMerchantAdmin() && self._hasFeature(FEATURE_CODES.ROLLOVER)) {
        if (self._isCompanyUser && brand !== 'r2w') {
          self.items.push({
            id: 'app.rollover',
            name: $translate.instant('ASIDE_MENU_ROLLOVER'),
            icon: 'assets/icons/ic_rollover_white.svg',
            link: '',
            subMenuItems: []
          });
        }
        self.shouldHideSidebar = true;
        return; // Exit early - Cashier only sees Rollover
      }

      self.items.push({
        id: 'app.dashboardTechnology',
        name:
          brand === 'karcher'
            ? $translate.instant('ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY')
            : $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY'),
        icon: 'assets/icons/ic-dashboard-white.svg',
        link: '',
        subMenuItems: []
      });
      if (checkUserRole.isMerchantAdmin() && self._isCompanyUser && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.DAILYFINANCES))) {
        self.items.push({
          id: 'app.dashboardFinancial',
          name: $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL'),
          icon: 'assets/icons/ic-daily-finances-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) {
        self.items.push({
          id: 'app.organization',
          name: $translate.instant('ORGANIZATION'),
          icon: 'assets/icons/ic_organization_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if ((checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.APPSITEDETAILS)) ) {
        self.items.push({
          id: 'app.workingSchedules',
          name: $translate.instant('ASIDE_WORKING_SCHEDULES'),
          icon: 'assets/icons/ic_content_paste_white_48px.svg',
          link: '',
          subMenuItems: [],
          roles: []
        });
      }
      self.items.push({
        id: 'app.alarms',
        name: $translate.instant('ASIDE_MENU_ALARMS'),
        icon: 'assets/icons/ic-messages-white.svg',
        link: '',
        subMenuItems: []
      });
      if ((
        checkUserRole.isMerchantAdmin() ||
        checkUserRole.isAdministrator() ||
        checkUserRole.isTechnicalSupportUser() ||
        checkUserRole.isControllerUser())
      ) {
        self.items.push({
          id: 'app.reports',
          name: $translate.instant('ASIDE_MENU_REPORTS'),
          icon: 'assets/icons/ic-reports-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && self._isCompanyUser ) {
        self.items.push({
          id: 'app.cashlessSales',
          name: $translate.instant('ASIDE_MENU_CASHLESS_SALES'),
          icon: 'assets/icons/ic_cashless.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.USER_GROUPS)) ) {
        self.items.push({
          id: 'app.userGroups',
          name: $translate.instant('ASIDE_MENU_USER_GROUPS'),
          icon: 'assets/icons/ic-user-groups-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.LOYALTY))) {
        self.items.push({
          id: 'app.loyalty',
          name: $translate.instant('ASIDE_MENU_LOYALTY'),
          icon: 'assets/icons/ic-loyalty-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.PERIODICSUMMARY))) {
        self.items.push({
          id: 'app.periodicSummary',
          name: $translate.instant('ASIDE_MENU_PERIODIC_SUMMARY'),
          icon: 'assets/icons/ic-periodic-summary-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if ((checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.VOUCHERS))) {
        self.items.push({
          id: 'app.vouchers',
          name: $translate.instant('ASIDE_MENU_VOUCHERS'),
          icon: 'assets/icons/ic-vouchers-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if ((checkUserRole.isMerchantAdmin() || checkUserRole.isCashier()) && self._isCompanyUser && self._hasFeature(FEATURE_CODES.ROLLOVER)) {
        self.items.push({
          id: 'app.rollover',
          name: $translate.instant('ASIDE_MENU_ROLLOVER'),
          icon: 'assets/icons/ic_rollover_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.TRANSACTIONS))) {
        self.items.push({
          id: 'app.transactions',
          name: $translate.instant('ASIDE_MENU_TRANSACTIONS'),
          icon: 'assets/icons/ic-transactions-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.MANAGING_TOKENS))) {
        self.items.push({
          id: 'app.tokens',
          name: $translate.instant('ASIDE_MENU_MANAGING_TOKENS'),
          icon: 'assets/icons/coins_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || self._hasFeature(FEATURE_CODES.PRICING))) {
        self.items.push({
          id: 'app.pricing',
          name: $translate.instant('PRICING'),
          icon: 'assets/icons/ic_dolar_circle_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      // SAVINGS - configurable via optional features
      if (checkUserRole.isMerchantAdmin() && self._isCompanyUser && self._hasFeature(FEATURE_CODES.SAVINGS)) {
        self.items.push({
          id: 'app.savings',
          name: $translate.instant('ASIDE_MENU_SAVINGS'),
          icon: 'assets/icons/ic_savings_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      // MONEY CHANGER JOURNAL - configurable via optional features
      if (checkUserRole.isMerchantAdmin() && self._isCompanyUser && self._hasFeature(FEATURE_CODES.MONEYCHANGERJOURNAL)) {
        self.items.push({
          id: 'app.moneyChangerJournal',
          name: $translate.instant('ASIDE_MENU_MONEY_CHANGER_JOURNAL'),
          icon: 'assets/images/changer_new.svg',
          link: '',
          subMenuItems: []
        });
      }

      // Hide sidebar if user has access to only one tab or no tabs
      if (this.items.length <= 2) {
        this.shouldHideSidebar = true;
      }
    };

    return AsideMenuViewModel;
  }
})();
